var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tarifas" },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.showInfoDialog,
            callback: function($$v) {
              _vm.showInfoDialog = $$v
            },
            expression: "showInfoDialog"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v("Vehículos")]
              )
            ],
            1
          ),
          _c("v-divider"),
          _c("v-card", { attrs: { id: "bodyDialogInfo" } }, [
            _c(
              "div",
              { staticStyle: { "margin-left": "20px" } },
              _vm._l(_vm.infoItems, function(item) {
                return _c(
                  "div",
                  { key: item.index, staticClass: "itemInfoDiv" },
                  [
                    _c("li", [
                      _vm._v("\n            " + _vm._s(item) + "\n          ")
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ],
        1
      ),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
            _c(
              "div",
              { attrs: { align: "left" } },
              [
                _c("v-text-field", {
                  attrs: {
                    "append-icon": "search",
                    label: "Buscar...",
                    "single-line": "",
                    "hide-details": ""
                  },
                  on: { input: _vm.onFilterTextBoxChanged },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                })
              ],
              1
            )
          ]),
          _c("v-flex", { attrs: { xs12: "", sm6: "", md4: "" } }, [
            _c("div", {
              staticStyle: { "padding-top": "15px" },
              attrs: { align: "right" }
            })
          ]),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { "padding-right": "20px" },
                      attrs: { color: "#ffe800" },
                      on: {
                        click: function($event) {
                          return _vm.handleCrear()
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { color: "black" },
                          attrs: { dark: "", left: "" }
                        },
                        [_vm._v("add_circle_outline")]
                      ),
                      _c("span", { staticStyle: { color: "black" } }, [
                        _vm._v("Crear")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card proveedores" },
        [
          _c("MantenedorGridSinCodigo", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "400px",
              "font-family": "'Asap' sans-serif"
            },
            attrs: {
              gridOptions: _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _c("CrearAlertaModal", {
        attrs: {
          show: _vm.mostrarModalCrear,
          alerta: _vm.alerta,
          edit: _vm.edit
        },
        on: {
          cerrar: function($event) {
            return _vm.handleCierreModal()
          }
        }
      }),
      _c("EditarAlertaModal", {
        attrs: {
          show: _vm.mostrarModalEditar,
          alerta: _vm.alerta,
          edit: _vm.edit
        },
        on: {
          cerrar: function($event) {
            return _vm.handleCierreModal()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }